import React, { useState, useEffect, useMemo } from 'react';
import './configuracionSku.scss';
import ToastGeneral from '../../components/toast/toast';

// API
import { insertPriceHistory } from '../../api/configuracionSku';

// Hooks personalizados
import { useConfiguracionSku } from './hooks/useConfiguracionSku';
import { useProductosModificados } from './hooks/useProductosModificados';
import { useCompetencias } from './hooks/useCompetencias';
import { useToast } from './hooks/useToast';
import { useGuardarCambios } from './hooks/useGuardarCambios';

// Componentes
import ClienteSelector from './components/ClienteSelector';
import FiltrosProductos from './components/FiltrosProductos';
import ListaProductos from './components/ListaProductos';
import ListaCompetencias from './components/ListaCompetencias';
import Paginacion from './components/Paginacion';
import NoClienteSeleccionado from './components/NoClienteSeleccionado';
import ModalEdicionMultiple from './components/ModalEdicionMultiple';

export default function ConfiguracionSku() {
  // Estados para manejar el tab activo
  const [activeTab, setActiveTab] = useState('sku');
  
  // Estados para la vista de competencias
  const [selectedClientCompetencias, setSelectedClientCompetencias] = useState(null);
  const [searchTermCompetencias, setSearchTermCompetencias] = useState('');
  const [showClientDropdownCompetencias, setShowClientDropdownCompetencias] = useState(false);
  
  // Estados para filtros de competencias
  const [filtroCategoriaCompetencias, setFiltroCategoriaCompetencias] = useState('');
  const [filtroSubcategoriaCompetencias, setFiltroSubcategoriaCompetencias] = useState('');
  const [filtroMarcaCompetencias, setFiltroMarcaCompetencias] = useState('');
  const [buscadorProductosCompetencias, setBuscadorProductosCompetencias] = useState('');
  const [mostrarFiltrosCompetencias, setMostrarFiltrosCompetencias] = useState(true);
  
  // Estados para paginación
  const [paginaActual, setPaginaActual] = useState(1);
  const [paginaActualCompetencias, setPaginaActualCompetencias] = useState(1);
  const elementosPorPagina = 20;
  
  // Estados para filtros
  const [filtroCategoria, setFiltroCategoria] = useState('');
  const [filtroSubcategoria, setFiltroSubcategoria] = useState('');
  const [filtroMarca, setFiltroMarca] = useState('');
  const [buscadorProductos, setBuscadorProductos] = useState('');
  const [mostrarFiltros, setMostrarFiltros] = useState(true);
  
  // Estados para manejar cambios en productos
  const [openMenus, setOpenMenus] = useState({});
  const [selectedClient, setSelectedClient] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [showClientDropdown, setShowClientDropdown] = useState(false);
  const [productosData, setProductosData] = useState({});
  
  // Estados para el modal de edición múltiple
  const [modalEdicionMultiple, setModalEdicionMultiple] = useState({
    isOpen: false,
    guardando: false
  });

  // Hooks personalizados
  const {
    skusData,
    loading,
    error,
    competenciasAsignadas,
    cargandoCompetencias,
    clientesConProductos,
    fetchSkus,
    obtenerTodasLasCompetenciasAsignadas,
    setCompetenciasAsignadas,
    setCargandoCompetencias
  } = useConfiguracionSku();

  const {
    productosModificados,
    competenciasAgregadas,
    competenciasEliminadas,
    preciosCompetenciasModificados,
    guardando,
    setGuardando,
    handleUnidadChange,
    handleCantidadChange,
    handlePrecioChange,
    handleMonedaChange,
    handleCompetenciaChange: handleCompetenciaChangeOriginal,
    handleCompetenciaCantidadChange: handleCompetenciaCantidadChangeOriginal,
    handleCompetenciaPrecioChange: handleCompetenciaPrecioChangeOriginal,
    limpiarCambios,
    setCompetenciasAgregadas,
    setCompetenciasEliminadas
  } = useProductosModificados();

  // Wrapper para handleCompetenciaChange con parámetros adicionales
  const handleCompetenciaChange = (productoId, competenciaIndex, nuevoSku, opcionesDisponibles) => {
    handleCompetenciaChangeOriginal(productoId, competenciaIndex, nuevoSku, setProductosData, selectedClient, opcionesDisponibles);
  };

  // Wrapper para handleCompetenciaCantidadChange con parámetros adicionales
  const handleCompetenciaCantidadChange = (productoId, competenciaIndex, nuevaCantidad) => {
    handleCompetenciaCantidadChangeOriginal(productoId, competenciaIndex, nuevaCantidad, setProductosData, selectedClient);
  };

  // Wrapper para handleCompetenciaPrecioChange con parámetros adicionales
  const handleCompetenciaPrecioChange = (productoId, competenciaIndex, nuevoPrecio) => {
    handleCompetenciaPrecioChangeOriginal(productoId, competenciaIndex, nuevoPrecio, setProductosData, selectedClient);
  };

  const { actualizandoCompetencia, competenciaLocal, actualizarCompetencia } = useCompetencias();
  const { toastConfig, mostrarToast } = useToast();
  const { guardarCambios } = useGuardarCambios();

  const toggleMenu = (id) => {
    const isOpening = !openMenus[id];
    
    setOpenMenus(prev => ({
      ...prev,
      [id]: !prev[id]
    }));

    // Si se está abriendo el acordeón, cargar las competencias asignadas desde el estado
    if (isOpening) {
      const competenciasAsignadas = obtenerCompetenciasAsignadas(id);
      
      if (competenciasAsignadas.length > 0) {
        // Actualizar el estado de productos con las competencias asignadas
        setProductosData(prev => {
          if (!selectedClient) return prev;
          
          const clienteId = selectedClient.id;
          const productosCliente = prev[clienteId] || [];
          
          const productoIndex = productosCliente.findIndex(p => p.id === id);
          if (productoIndex === -1) return prev;
          
          const nuevosProductos = [...productosCliente];
          
          // Crear competencias con los IDs obtenidos de la API
          const competenciasConIds = competenciasAsignadas.map(comp => {
            // Obtener datos completos de la competencia desde la tabla products
            const datosCompetencia = obtenerDatosCompetencia(comp.ID_COMPETENCE);
            
            console.log('🔍 Competencia cargada:', {
              ID: comp.ID,
              ID_COMPETENCE: comp.ID_COMPETENCE,
              QTY_competence_table: comp.QTY,
              datosCompetencia: datosCompetencia,
              QTY_products_table: datosCompetencia?.cantidad,
              QTY_final: datosCompetencia?.cantidad !== null && datosCompetencia?.cantidad !== undefined 
                ? datosCompetencia.cantidad 
                : (comp.QTY !== null && comp.QTY !== undefined ? comp.QTY : "")
            });
            
            return {
              id: comp.ID,
              sku: comp.ID_COMPETENCE,
              dateInsert: comp.DATE_INSERT,
              // Inicializar con QTY de la tabla products si está disponible, sino usar el de competence_table
              // El usuario podrá editar este valor después
              cantidad: datosCompetencia?.cantidad !== null && datosCompetencia?.cantidad !== undefined 
                ? datosCompetencia.cantidad 
                : (comp.QTY !== null && comp.QTY !== undefined ? comp.QTY : "")
            };
          });
          
          nuevosProductos[productoIndex] = {
            ...nuevosProductos[productoIndex],
            competencias: competenciasConIds
          };
          
          return {
            ...prev,
            [clienteId]: nuevosProductos
          };
        });
      }
    }
  };

  const handleClientSelect = (cliente) => {
    setSelectedClient(cliente);
    setSearchTerm(cliente.nombre_cliente);
    setShowClientDropdown(false);
    setOpenMenus({}); // Cerrar todos los menús al cambiar de cliente
    
    // Limpiar filtros al cambiar de cliente
    limpiarFiltros();
    
    // Filtrar SKUs por cliente seleccionado usando ID_CLIENT y solo aquellos con competence en false
    const clienteId = parseInt(cliente.id);
    const skusDelCliente = skusData.filter(sku => 
      sku.ID_CLIENT === clienteId && sku.COMPETENCE === false
    );
    
    // Mapear productos con la estructura correcta de la base de datos
    const productosConCompetencias = skusDelCliente.map((sku, index) => {
      // Log del primer producto para ver TODAS las columnas disponibles
      if (index === 0) {
        console.log('📊 Primer producto SKU - TODAS las columnas:', Object.keys(sku));
        console.log('📊 Primer producto SKU - Datos completos:', sku);
      }
      
      // Buscar el precio en diferentes formatos por si PostgreSQL lo devuelve en mayúsculas o minúsculas
      const precio = sku.PRICE_DS || sku.price_ds || sku['PRICE_DS'] || 0;
      const rate = sku.RATE || sku.rate || sku['RATE'] || 0;
      
      console.log(`📊 Mapeando producto ${sku.ID} (${sku.SKU}):`, {
        ID: sku.ID,
        PRICE_DS: sku.PRICE_DS,
        price_ds: sku.price_ds,
        precioFinal: precio,
        rate: rate
      });
      
      return {
        id: sku.ID,
        nombre: sku.SKU,
        categoria: sku.CATEGORY,
        subcategoria: sku.SUBCATEGORY,
        marca: sku.BRAND,
        unidad: sku.UNIT,
        cantidad: sku.QTY,
        precio: precio, // Precio desde products_price_history
        rate: rate,
        priceStartDate: sku.price_start_date,
        activo: sku.ACTIVE,
        competence: sku.COMPETENCE,
        competencias: []
      };
    });
    
    setProductosData(prev => ({
      ...prev,
      [cliente.id]: productosConCompetencias
    }));
  };

  // Función para manejar la selección de cliente en la vista de competencias
  const handleClientSelectCompetencias = (cliente) => {
    setSelectedClientCompetencias(cliente);
    setSearchTermCompetencias(cliente.nombre_cliente);
    setShowClientDropdownCompetencias(false);
    
    // Limpiar filtros al cambiar de cliente
    limpiarFiltrosCompetencias();
  };

  const addCompetencia = (productoId) => {
    if (!selectedClient) return;
    
    setProductosData(prev => {
      const clienteId = selectedClient.id;
      const productosCliente = prev[clienteId] || selectedClient.productos.map(p => ({ ...p, competencias: [] }));
      
      const productoIndex = productosCliente.findIndex(p => p.id === productoId);
      if (productoIndex === -1) return prev;
      
      const nuevosProductos = [...productosCliente];
      nuevosProductos[productoIndex] = {
        ...nuevosProductos[productoIndex],
        competencias: [...(nuevosProductos[productoIndex].competencias || []), { 
          id: `comp_${Date.now()}`, 
          sku: '', 
          cantidad: 0 
        }]
      };
      
      return {
        ...prev,
        [clienteId]: nuevosProductos
      };
    });
  };

  const removeCompetencia = (productoId, competenciaIndex) => {
    if (!selectedClient) return;
    
    // Obtener información de la competencia antes de eliminarla
    const clienteId = selectedClient.id;
    const productosCliente = productosData[clienteId] || [];
    const productoIndex = productosCliente.findIndex(p => p.id === productoId);
    
    if (productoIndex === -1) return;
    
    const competenciaAEliminar = productosCliente[productoIndex].competencias[competenciaIndex];
    
    // Proceder directamente con la eliminación
    setProductosData(prev => {
      const clienteId = selectedClient.id;
      const productosCliente = prev[clienteId] || selectedClient.productos.map(p => ({ ...p, competencias: [] }));
      
      const productoIndex = productosCliente.findIndex(p => p.id === productoId);
      if (productoIndex === -1) return prev;
      
      const nuevosProductos = [...productosCliente];
      const competenciaAEliminar = nuevosProductos[productoIndex].competencias[competenciaIndex];
      
      // Si la competencia tiene un ID (ya existe en la base de datos), la marcamos como eliminada
      if (competenciaAEliminar && competenciaAEliminar.id && !competenciaAEliminar.id.toString().startsWith('comp_')) {
        setCompetenciasEliminadas(prev => ({
          ...prev,
          [productoId]: [
            ...(prev[productoId] || []),
            {
              id: competenciaAEliminar.id,
              competenceId: competenciaAEliminar.sku
            }
          ]
        }));
      }
      
      // Si la competencia fue agregada recientemente (tiene ID temporal), la removemos de competenciasAgregadas
      if (competenciaAEliminar && competenciaAEliminar.id && competenciaAEliminar.id.toString().startsWith('comp_')) {
        setCompetenciasAgregadas(prev => {
          const competenciasProducto = prev[productoId] || [];
          const nuevasCompetencias = competenciasProducto.filter(comp => 
            comp.index !== competenciaIndex || comp.competenceId !== competenciaAEliminar.sku
          );
          return {
            ...prev,
            [productoId]: nuevasCompetencias
          };
        });
      }
      
      const nuevasCompetencias = nuevosProductos[productoIndex].competencias.filter((_, index) => index !== competenciaIndex);
      
      nuevosProductos[productoIndex] = {
        ...nuevosProductos[productoIndex],
        competencias: nuevasCompetencias
      };
      
      return {
        ...prev,
        [clienteId]: nuevosProductos
      };
    });
  };

  const filteredClientes = clientesConProductos.filter(cliente => {
    const nombreCliente = cliente.nombre || cliente.NAME || cliente.name || cliente.nombre_cliente || '';
    return nombreCliente && nombreCliente.toLowerCase().includes(searchTerm.toLowerCase());
  });

  // Filtrar clientes para la vista de competencias
  const filteredClientesCompetencias = clientesConProductos.filter(cliente => {
    const nombreCliente = cliente.nombre || cliente.NAME || cliente.name || cliente.nombre_cliente || '';
    return nombreCliente && nombreCliente.toLowerCase().includes(searchTermCompetencias.toLowerCase());
  });

  const productosActuales = selectedClient ? 
    (productosData[selectedClient.id || selectedClient.ID] || []) : 
    [];

  // Obtener opciones únicas para los filtros
  const opcionesFiltros = useMemo(() => {
    if (!productosActuales || productosActuales.length === 0) {
      return {
        categorias: [],
        subcategorias: [],
        marcas: []
      };
    }

    const categorias = [...new Set(productosActuales.map(p => p.categoria).filter(Boolean))].sort();
    const subcategorias = [...new Set(productosActuales.map(p => p.subcategoria).filter(Boolean))].sort();
    const marcas = [...new Set(productosActuales.map(p => p.marca).filter(Boolean))].sort();

    return {
      categorias,
      subcategorias,
      marcas
    };
  }, [productosActuales]);

  // Filtrar productos según los filtros aplicados
  const productosFiltrados = useMemo(() => {
    if (!productosActuales || productosActuales.length === 0) return [];

    return productosActuales.filter(producto => {
      // Filtro por categoría
      if (filtroCategoria && producto.categoria !== filtroCategoria) {
        return false;
      }

      // Filtro por subcategoría
      if (filtroSubcategoria && producto.subcategoria !== filtroSubcategoria) {
        return false;
      }

      // Filtro por marca
      if (filtroMarca && producto.marca !== filtroMarca) {
        return false;
      }

      // Filtro por texto (búsqueda)
      if (buscadorProductos) {
        const terminoBusqueda = buscadorProductos.toLowerCase();
        const nombreProducto = (producto.nombre || '').toLowerCase();
        const categoriaProducto = (producto.categoria || '').toLowerCase();
        const subcategoriaProducto = (producto.subcategoria || '').toLowerCase();
        const marcaProducto = (producto.marca || '').toLowerCase();

        if (!nombreProducto.includes(terminoBusqueda) &&
            !categoriaProducto.includes(terminoBusqueda) &&
            !subcategoriaProducto.includes(terminoBusqueda) &&
            !marcaProducto.includes(terminoBusqueda)) {
          return false;
        }
      }

      return true;
    });
  }, [productosActuales, filtroCategoria, filtroSubcategoria, filtroMarca, buscadorProductos]);

  // Calcular paginación para productos SKU
  const totalPaginas = Math.ceil(productosFiltrados.length / elementosPorPagina);
  const indiceInicio = (paginaActual - 1) * elementosPorPagina;
  const indiceFin = indiceInicio + elementosPorPagina;
  const productosPaginados = productosFiltrados.slice(indiceInicio, indiceFin);

  // Función para limpiar todos los filtros
  const limpiarFiltros = () => {
    setFiltroCategoria('');
    setFiltroSubcategoria('');
    setFiltroMarca('');
    setBuscadorProductos('');
  };

  // Función para limpiar todos los filtros de competencias
  const limpiarFiltrosCompetencias = () => {
    setFiltroCategoriaCompetencias('');
    setFiltroSubcategoriaCompetencias('');
    setFiltroMarcaCompetencias('');
    setBuscadorProductosCompetencias('');
  };

  // Funciones para manejar paginación
  const cambiarPagina = (nuevaPagina) => {
    setPaginaActual(nuevaPagina);
  };

  const cambiarPaginaCompetencias = (nuevaPagina) => {
    setPaginaActualCompetencias(nuevaPagina);
  };

  // Resetear paginación cuando cambien los filtros
  useEffect(() => {
    setPaginaActual(1);
  }, [filtroCategoria, filtroSubcategoria, filtroMarca, buscadorProductos, selectedClient]);

  useEffect(() => {
    setPaginaActualCompetencias(1);
  }, [filtroCategoriaCompetencias, filtroSubcategoriaCompetencias, filtroMarcaCompetencias, buscadorProductosCompetencias, selectedClientCompetencias]);

  // Función para obtener competencias asignadas para un producto específico
  const obtenerCompetenciasAsignadas = (productoId) => {
    return competenciasAsignadas[productoId] || [];
  };

  // Función para obtener productos con COMPETENCE en true para usar como competencias
  const getProductosCompetencia = useMemo(() => {
    if (!skusData || skusData.length === 0 || !selectedClient) return [];
    
    const clienteId = parseInt(selectedClient.id);
    
    // Filtrar productos que tengan COMPETENCE en true Y que pertenezcan al mismo cliente
    const productosCompetencia = skusData.filter(sku => 
      sku.COMPETENCE === true && sku.ID_CLIENT === clienteId
    );
    
    // Mapear a formato de opciones para el select
    return productosCompetencia.map(sku => ({
      value: sku.ID.toString(),
      label: sku.SKU,
      categoria: sku.CATEGORY,
      subcategoria: sku.SUBCATEGORY,
      marca: sku.BRAND,
      unidad: sku.UNIT,
      cantidad: sku.QTY,
      precio: sku.PRICE_DS || sku.price_ds || sku['PRICE_DS'] || 0 // Precio desde products_price_history
    }));
  }, [skusData, selectedClient]);

  // Función para obtener productos de competencias para la vista de competencias
  const getProductosCompetenciasVista = useMemo(() => {
    if (!skusData || skusData.length === 0 || !selectedClientCompetencias) return [];
    
    const clienteId = parseInt(selectedClientCompetencias.id);
    
    // Filtrar TODOS los productos que pertenezcan al cliente seleccionado (sin filtros de COMPETENCE o ACTIVE)
    const productosCliente = skusData.filter(sku => 
      sku.ID_CLIENT === clienteId
    );
    
    // Mapear productos con la estructura correcta
    return productosCliente.map(sku => ({
      id: sku.ID,
      nombre: sku.SKU,
      categoria: sku.CATEGORY,
      subcategoria: sku.SUBCATEGORY,
      marca: sku.BRAND,
      unidad: sku.UNIT,
      cantidad: sku.QTY,
      precio: sku.PRICE_DS || sku.price_ds || sku['PRICE_DS'] || 0, // Precio desde products_price_history
      activo: sku.ACTIVE,
      competence: sku.COMPETENCE
    }));
  }, [skusData, selectedClientCompetencias]);

  // Obtener opciones únicas para los filtros de competencias
  const opcionesFiltrosCompetencias = useMemo(() => {
    if (!getProductosCompetenciasVista || getProductosCompetenciasVista.length === 0) {
      return {
        categorias: [],
        subcategorias: [],
        marcas: []
      };
    }

    const categorias = [...new Set(getProductosCompetenciasVista.map(p => p.categoria).filter(Boolean))].sort();
    const subcategorias = [...new Set(getProductosCompetenciasVista.map(p => p.subcategoria).filter(Boolean))].sort();
    const marcas = [...new Set(getProductosCompetenciasVista.map(p => p.marca).filter(Boolean))].sort();

    return {
      categorias,
      subcategorias,
      marcas
    };
  }, [getProductosCompetenciasVista]);

  // Filtrar productos de competencias según los filtros aplicados
  const productosCompetenciasFiltrados = useMemo(() => {
    if (!getProductosCompetenciasVista || getProductosCompetenciasVista.length === 0) return [];

    return getProductosCompetenciasVista.filter(producto => {
      // Filtro por categoría
      if (filtroCategoriaCompetencias && producto.categoria !== filtroCategoriaCompetencias) {
        return false;
      }

      // Filtro por subcategoría
      if (filtroSubcategoriaCompetencias && producto.subcategoria !== filtroSubcategoriaCompetencias) {
        return false;
      }

      // Filtro por marca
      if (filtroMarcaCompetencias && producto.marca !== filtroMarcaCompetencias) {
        return false;
      }

      // Filtro por texto (búsqueda)
      if (buscadorProductosCompetencias) {
        const terminoBusqueda = buscadorProductosCompetencias.toLowerCase();
        const nombreProducto = (producto.nombre || '').toLowerCase();
        const categoriaProducto = (producto.categoria || '').toLowerCase();
        const subcategoriaProducto = (producto.subcategoria || '').toLowerCase();
        const marcaProducto = (producto.marca || '').toLowerCase();

        if (!nombreProducto.includes(terminoBusqueda) &&
            !categoriaProducto.includes(terminoBusqueda) &&
            !subcategoriaProducto.includes(terminoBusqueda) &&
            !marcaProducto.includes(terminoBusqueda)) {
          return false;
        }
      }

      return true;
    });
  }, [getProductosCompetenciasVista, filtroCategoriaCompetencias, filtroSubcategoriaCompetencias, filtroMarcaCompetencias, buscadorProductosCompetencias]);

  // Calcular paginación para competencias
  const totalPaginasCompetencias = Math.ceil(productosCompetenciasFiltrados.length / elementosPorPagina);
  const indiceInicioCompetencias = (paginaActualCompetencias - 1) * elementosPorPagina;
  const indiceFinCompetencias = indiceInicioCompetencias + elementosPorPagina;
  const productosCompetenciasPaginados = productosCompetenciasFiltrados.slice(indiceInicioCompetencias, indiceFinCompetencias);

  // Función para obtener opciones disponibles de competencias para un producto específico
  const getOpcionesCompetenciasDisponibles = (productoId, competenciaIndex) => {
    const producto = productosActuales.find(p => p.id === productoId);
    if (!producto || !producto.competencias) return [];

    // Obtener SKUs ya seleccionados en otras competencias del mismo producto
    const skusSeleccionados = producto.competencias
      .map((comp, index) => index !== competenciaIndex ? comp.sku : null)
      .filter(sku => sku && sku !== '');

    // Usar los productos con COMPETENCE en true como opciones
    const todasLasOpciones = getProductosCompetencia;

    // Filtrar opciones excluyendo las ya seleccionadas
    return todasLasOpciones.filter(opcion => !skusSeleccionados.includes(opcion.value));
  };

  // Función para obtener datos completos de una competencia desde la tabla products
  const obtenerDatosCompetencia = (competenciaId) => {
    if (!skusData || !competenciaId) return null;
    
    // Buscar el producto en skusData que coincida con el ID_COMPETENCE
    const competenciaData = skusData.find(sku => sku.ID.toString() === competenciaId.toString());
    
    if (competenciaData) {
      return {
        id: competenciaData.ID,
        nombre: competenciaData.SKU,
        categoria: competenciaData.CATEGORY,
        subcategoria: competenciaData.SUBCATEGORY,
        marca: competenciaData.BRAND,
        unidad: competenciaData.UNIT,
        cantidad: competenciaData.QTY, // ⭐ Este es el QTY que necesitamos
        precio: competenciaData.PRICE_DS || competenciaData.price_ds || competenciaData['PRICE_DS'] || 0, // Precio desde products_price_history
        activo: competenciaData.ACTIVE,
        competence: competenciaData.COMPETENCE
      };
    }
    
    return null;
  };

  // Función para manejar el guardado de cambios
  const handleGuardarCambios = () => {
    guardarCambios(
      selectedClient,
      productosModificados,
      competenciasAgregadas,
      competenciasEliminadas,
      preciosCompetenciasModificados,
      setGuardando,
      mostrarToast,
      limpiarCambios,
      setCompetenciasAsignadas,
      setCargandoCompetencias,
      obtenerTodasLasCompetenciasAsignadas,
      productosData,
      fetchSkus,
      setProductosData,
      skusData
    );
  };

  // Función para manejar la actualización de competencias
  const handleActualizarCompetencia = (productoId, nuevoValor) => {
    actualizarCompetencia(productoId, nuevoValor, mostrarToast);
  };

  // Función para abrir el modal de edición múltiple
  const abrirModalEdicionMultiple = () => {
    setModalEdicionMultiple({
      isOpen: true,
      guardando: false
    });
  };

  // Función para cerrar el modal de edición múltiple
  const cerrarModalEdicionMultiple = () => {
    setModalEdicionMultiple({
      isOpen: false,
      guardando: false
    });
  };

  // Función para guardar los cambios desde el modal de edición múltiple
  const guardarEdicionMultiple = async (cambios) => {
    setModalEdicionMultiple(prev => ({ ...prev, guardando: true }));
    
    try {
      // Obtener datos del usuario desde localStorage
      const userData = JSON.parse(localStorage.getItem("userData") || "{}");
      const userUid = userData.uid || userData.id || null;
      
      if (!userUid) {
        mostrarToast('error', 'No se pudo identificar el usuario. Por favor, inicie sesión nuevamente.');
        setModalEdicionMultiple(prev => ({ ...prev, guardando: false }));
        return;
      }
      
      // Preparar los cambios de precio en el formato correcto para insertPriceHistory
      const cambiosPrecioHistorial = cambios.map(cambio => ({
        idProduct: parseInt(cambio.id),
        priceDs: parseFloat(cambio.precio) || 0,
        rate: 0, // Por defecto 0, como en useGuardarCambios
        userUid: userUid
      }));
      
      console.log(`📊 Guardando historial de ${cambiosPrecioHistorial.length} cambios de precio...`, cambiosPrecioHistorial);
      
      // Llamar a la API para insertar el historial de precios
      const historialResponse = await insertPriceHistory(cambiosPrecioHistorial);
      
      if (historialResponse.data?.success) {
        console.log('✅ Historial de precios guardado exitosamente');
        
        // Actualizar el estado local de productos con los nuevos precios
        setProductosData(prev => {
          if (!selectedClient) return prev;
          
          const clienteId = selectedClient.id;
          const productosCliente = prev[clienteId] || [];
          
          const productosActualizados = productosCliente.map(producto => {
            const cambio = cambios.find(c => c.id === producto.id);
            if (cambio) {
              return {
                ...producto,
                precio: cambio.precio
              };
            }
            return producto;
          });
          
          return {
            ...prev,
            [clienteId]: productosActualizados
          };
        });
        
        // Recargar skusData para que el modal muestre los precios actualizados
        console.log('🔄 Recargando datos de SKUs para reflejar los nuevos precios...');
        await fetchSkus();
        
        // Mostrar mensaje de éxito
        mostrarToast('success', `Se actualizaron ${cambios.length} precio(s) correctamente`);
        
        // Cerrar el modal
        cerrarModalEdicionMultiple();
      } else {
        console.warn('⚠️ Advertencia al guardar historial de precios:', historialResponse.data);
        mostrarToast('error', 'Hubo un problema al guardar los cambios. Por favor, inténtelo de nuevo.');
        setModalEdicionMultiple(prev => ({ ...prev, guardando: false }));
      }
      
    } catch (error) {
      console.error('Error al guardar cambios múltiples:', error);
      mostrarToast('error', `Error al guardar los cambios: ${error.message || 'Por favor, inténtelo de nuevo'}`);
      
      setModalEdicionMultiple(prev => ({ ...prev, guardando: false }));
    }
  };

  // Mostrar estado de carga
  if (loading) {
    return (
      <div className="configuracion-sku-container">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <h2 className="card-title">Configuración SKU</h2>
              </div>
              <div className="card-body">
                <div className="text-center py-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Cargando...</span>
                  </div>
                  <p className="mt-3 text-muted">Cargando datos...</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Mostrar estado de error
  if (error) {
    return (
      <div className="configuracion-sku-container">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <h2 className="card-title">Configuración SKU</h2>
              </div>
              <div className="card-body">
                <div className="alert alert-danger" role="alert">
                  <i className="fas fa-exclamation-triangle me-2"></i>
                  {error}
                </div>
                <button 
                  className="btn btn-primary"
                  onClick={() => window.location.reload()}
                >
                  <i className="fas fa-refresh me-2"></i>
                  Reintentar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="configuracion-sku-container">
      {/* Componente de notificaciones toast */}
      {toastConfig.isVisible && (
        <ToastGeneral 
          type={toastConfig.type}
          message={toastConfig.message}
        />
      )}
      
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <h2 className="card-title">Configuración SKU</h2>
              
              {/* Navegación de tabs */}
              <ul className="nav nav-tabs card-header-tabs mt-3" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${activeTab === 'sku' ? 'active' : ''}`}
                    onClick={() => setActiveTab('sku')}
                    type="button"
                    role="tab"
                  >
                    <i className="fas fa-cogs me-2"></i>
                    Configuración de SKU
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${activeTab === 'competencias' ? 'active' : ''}`}
                    onClick={() => setActiveTab('competencias')}
                    type="button"
                    role="tab"
                  >
                    <i className="fas fa-link me-2"></i>
                    Configuración de Competencias
                  </button>
                </li>
              </ul>
            </div>
            <div className="card-body">
              {/* Contenido de tabs */}
              <div className="tab-content">
                {/* Tab de Configuración de SKU */}
                {activeTab === 'sku' && (
                  <div className="tab-pane fade show active" role="tabpanel">
                    <div className="row">
                      <div className="col-12">
                        <p className="text-muted mb-4">
                          Interfaz para la configuración de SKUs del sistema.
                        </p>
                        
                        {/* Buscador de Clientes */}
                        <ClienteSelector
                          searchTerm={searchTerm}
                          setSearchTerm={setSearchTerm}
                          showClientDropdown={showClientDropdown}
                          setShowClientDropdown={setShowClientDropdown}
                          filteredClientes={filteredClientes}
                          handleClientSelect={handleClientSelect}
                          selectedClient={selectedClient}
                          productosFiltrados={productosFiltrados}
                          productosActuales={productosActuales}
                          elementosPorPagina={elementosPorPagina}
                          paginaActual={paginaActual}
                          totalPaginas={totalPaginas}
                          mostrarFiltros={mostrarFiltros}
                          setMostrarFiltros={setMostrarFiltros}
                          skusData={skusData}
                          tipoVista="sku"
                        />

                        {/* Filtros y Buscador */}
                        {selectedClient && mostrarFiltros && (
                          <FiltrosProductos
                            opcionesFiltros={opcionesFiltros}
                            filtroCategoria={filtroCategoria}
                            setFiltroCategoria={setFiltroCategoria}
                            filtroSubcategoria={filtroSubcategoria}
                            setFiltroSubcategoria={setFiltroSubcategoria}
                            filtroMarca={filtroMarca}
                            setFiltroMarca={setFiltroMarca}
                            buscadorProductos={buscadorProductos}
                            setBuscadorProductos={setBuscadorProductos}
                            limpiarFiltros={limpiarFiltros}
                            guardarCambios={handleGuardarCambios}
                            guardando={guardando}
                            tipoVista="sku"
                            onAbrirEdicionMultiple={abrirModalEdicionMultiple}
                          />
                        )}

                        {/* Lista de Productos */}
                        {selectedClient ? (
                          <>
                            <ListaProductos
                              productosPaginados={productosPaginados}
                              skusData={skusData}
                              openMenus={openMenus}
                              toggleMenu={toggleMenu}
                              obtenerCompetenciasAsignadas={obtenerCompetenciasAsignadas}
                              handleUnidadChange={handleUnidadChange}
                              handleCantidadChange={handleCantidadChange}
                              handlePrecioChange={handlePrecioChange}
                              handleMonedaChange={handleMonedaChange}
                              handleCompetenciaChange={handleCompetenciaChange}
                              handleCompetenciaCantidadChange={handleCompetenciaCantidadChange}
                              handleCompetenciaPrecioChange={handleCompetenciaPrecioChange}
                              addCompetencia={addCompetencia}
                              removeCompetencia={removeCompetencia}
                              getOpcionesCompetenciasDisponibles={getOpcionesCompetenciasDisponibles}
                              obtenerDatosCompetencia={obtenerDatosCompetencia}
                              productosModificados={productosModificados}
                              guardarCambios={handleGuardarCambios}
                              guardando={guardando}
                              cargandoCompetencias={cargandoCompetencias}
                            />
                            
                            {/* Paginación para productos SKU */}
                            <Paginacion
                              paginaActual={paginaActual}
                              totalPaginas={totalPaginas}
                              cambiarPagina={cambiarPagina}
                              indiceInicio={indiceInicio}
                              indiceFin={indiceFin}
                              totalElementos={productosFiltrados.length}
                              tipoElemento="productos"
                            />
                          </>
                        ) : (
                          <NoClienteSeleccionado tipoVista="sku" />
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {/* Tab de Configuración de Competencias */}
                {activeTab === 'competencias' && (
                  <div className="tab-pane fade show active" role="tabpanel">
                    <div className="row">
                      <div className="col-12">
                        <p className="text-muted mb-4">
                          Interfaz para la configuración de competencias del sistema.
                        </p>
                        
                        {/* Buscador de Clientes para Competencias */}
                        <ClienteSelector
                          searchTerm={searchTermCompetencias}
                          setSearchTerm={setSearchTermCompetencias}
                          showClientDropdown={showClientDropdownCompetencias}
                          setShowClientDropdown={setShowClientDropdownCompetencias}
                          filteredClientes={filteredClientesCompetencias}
                          handleClientSelect={handleClientSelectCompetencias}
                          selectedClient={selectedClientCompetencias}
                          productosFiltrados={productosCompetenciasFiltrados}
                          productosActuales={getProductosCompetenciasVista}
                          elementosPorPagina={elementosPorPagina}
                          paginaActual={paginaActualCompetencias}
                          totalPaginas={totalPaginasCompetencias}
                          mostrarFiltros={mostrarFiltrosCompetencias}
                          setMostrarFiltros={setMostrarFiltrosCompetencias}
                          skusData={skusData}
                          tipoVista="competencias"
                        />

                        {/* Filtros y Buscador para Competencias */}
                        {selectedClientCompetencias && mostrarFiltrosCompetencias && (
                          <FiltrosProductos
                            opcionesFiltros={opcionesFiltrosCompetencias}
                            filtroCategoria={filtroCategoriaCompetencias}
                            setFiltroCategoria={setFiltroCategoriaCompetencias}
                            filtroSubcategoria={filtroSubcategoriaCompetencias}
                            setFiltroSubcategoria={setFiltroSubcategoriaCompetencias}
                            filtroMarca={filtroMarcaCompetencias}
                            setFiltroMarca={setFiltroMarcaCompetencias}
                            buscadorProductos={buscadorProductosCompetencias}
                            setBuscadorProductos={setBuscadorProductosCompetencias}
                            limpiarFiltros={limpiarFiltrosCompetencias}
                            tipoVista="competencias"
                          />
                        )}

                        {/* Lista de Productos de Competencias */}
                        {selectedClientCompetencias ? (
                          <>
                            <ListaCompetencias
                              productosCompetenciasPaginados={productosCompetenciasPaginados}
                              competenciaLocal={competenciaLocal}
                              actualizandoCompetencia={actualizandoCompetencia}
                              actualizarCompetencia={handleActualizarCompetencia}
                            />
                            
                            {/* Paginación para competencias */}
                            <Paginacion
                              paginaActual={paginaActualCompetencias}
                              totalPaginas={totalPaginasCompetencias}
                              cambiarPagina={cambiarPaginaCompetencias}
                              indiceInicio={indiceInicioCompetencias}
                              indiceFin={indiceFinCompetencias}
                              totalElementos={productosCompetenciasFiltrados.length}
                              tipoElemento="competencias"
                            />
                          </>
                        ) : (
                          <NoClienteSeleccionado tipoVista="competencias" />
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Modal de Edición Múltiple */}
      <ModalEdicionMultiple
        isOpen={modalEdicionMultiple.isOpen}
        onClose={cerrarModalEdicionMultiple}
        productosFiltrados={productosFiltrados}
        skusData={skusData}
        onGuardar={guardarEdicionMultiple}
        guardando={modalEdicionMultiple.guardando}
      />
    </div>
  );
}
